module.exports = __webpack_public_path__ + "img/n25.60a56d51.png";